import React from 'react';
import parse from 'html-react-parser';

export default function ChecklistItemFootnote({footnote}) {
  return footnote && (<div className="app-checklist-item-footnote">{parse(footnote)}</div>);
}
